import PopUp from "../../../components/containers/PopUp";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { getItemsPerCategoryDispatch } from "../../../server/Product";
import "./FamilyChangeDialog.scss";
import ReactDOM from "react-dom";

const FamilyChangeDialog = ({
  product,
  close,
  onConfirm,
  markedProducts,
  massage,
}) => {
  const dispatch = useDispatch();

  const { products, stationId } = useSelector((state) => ({
    products: state.displayProduct.itemsShow,
    stationId: state.user.stationId,
  }));

  const [selectedProducts, setSelectedProducts] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    setSelectedProducts(new Set(markedProducts.map((p) => p.Mkt)));
  }, [markedProducts]);

  useEffect(() => {
    dispatch(
      getItemsPerCategoryDispatch(product.Category.at(-1).Id, stationId, null),
    );
  }, []);

  const handleProductToggle = (productMkt) => {
    const newSelected = new Set(selectedProducts);
    if (newSelected.has(productMkt)) newSelected.delete(productMkt);
    else newSelected.add(productMkt);
    setSelectedProducts(newSelected);
    setSelectAll(newSelected.size === products.length);
  };

  const handleSelectAllToggle = () => {
    if (selectAll) {
      setSelectedProducts(new Set());
    } else {
      setSelectedProducts(new Set(products.map((prod) => prod.Mkt)));
    }
    setSelectAll(!selectAll);
  };

  const handleConfirm = () => {
    if (selectedProducts.size === 0) {
      alert("אנא בחר לפחות מוצר אחד לשינוי");
      return;
    }

    onConfirm(products.filter((prod) => selectedProducts.has(prod.Mkt)));
    close(false);
  };

  return ReactDOM.createPortal(
    <PopUp width="700px" close={() => close(false)}>
      <div className="family-change-dialog">
        <div className="dialog-header">
          <h3>שינוי מוצרים במשפחה</h3>
          <p>
            מוצר זה שייך למשפחת "
            <span className="category-name">
              {product.Category.at(-1).Name}
            </span>
            ".
          </p>
          <p>{massage}</p>
        </div>

        <div className="products-container">
          <div className="select-all-container">
            <label className="product-item select-all">
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAllToggle}
                className="product-checkbox"
              />
              <span className="product-details">
                <strong>בחר הכל ({products.length} מוצרים)</strong>
              </span>
            </label>
          </div>
          <div className="products-list">
            {products.map((prod) => (
              <label key={prod.Mkt} className="product-item">
                <input
                  type="checkbox"
                  checked={selectedProducts.has(prod.Mkt)}
                  onChange={() => handleProductToggle(prod.Mkt)}
                  className="product-checkbox"
                />
                <span className="product-details">
                  <span className="product-name">{prod.ProductName}</span>
                  <span className="product-price">₪{prod.Price}</span>
                </span>
              </label>
            ))}
          </div>
        </div>
        <div className="dialog-actions">
          <button
            className="confirm-button"
            onClick={handleConfirm}
            disabled={selectedProducts.size === 0}
          >
            אישור ({selectedProducts.size} מוצרים נבחרו)
          </button>
          <button className="cancel-button" onClick={() => close(false)}>
            ביטול
          </button>
        </div>
      </div>
    </PopUp>,
    document.body,
  );
};

export default FamilyChangeDialog;
